import React from 'react';
import SvgIcon from './SvgIcon';

/** @typedef {FF.SvgIcon  & {isFilled?: boolean}} PinSvgIcon */
/**
 * @param {PinSvgIcon} props
 */
function PinIcon(props) {
  const { isFilled } = props;
  if (isFilled) {
    return (
      <SvgIcon type="presentation" viewBox="0 0 32 32" {...props}>
        <path d="M4 12a12 12 0 0 1 24 0c0 8-12 20-12 20S4 20 4 12m7 0a5 5 0 0 0 10 0 5 5 0 0 0-10 0z" />
      </SvgIcon>
    );
  }
  return (
    <SvgIcon type="presentation" viewBox="0 0 17 24" {...props}>
      <path d="M8.5 0.75C12.8538 0.75 16.375 4.27125 16.375 8.625C16.375 14.5312 8.5 23.25 8.5 23.25C8.5 23.25 0.625 14.5312 0.625 8.625C0.625 4.27125 4.14625 0.75 8.5 0.75ZM8.5 3C5.395 3 2.875 5.52 2.875 8.625C2.875 11.8313 6.16 16.7362 8.5 19.74C10.885 16.7137 14.125 11.865 14.125 8.625C14.125 5.52 11.605 3 8.5 3ZM8.5 5.8125C10.0533 5.8125 11.3125 7.0717 11.3125 8.625C11.3125 10.1783 10.0533 11.4375 8.5 11.4375C6.9467 11.4375 5.6875 10.1783 5.6875 8.625C5.6875 7.0717 6.9467 5.8125 8.5 5.8125Z" />
    </SvgIcon>
  );
}

export default PinIcon;
